import { ReactElement } from 'react'
import { LifeLine } from 'react-loading-indicators'
import './Loaders.css'

const Loaders = (): ReactElement => {
  return (
    <div className='loading-container'>
      <LifeLine color='#004c91' size='large' />
    </div>
  )
}

export default Loaders
